/* ATV · Hero carousel — vanilla, multi-instance safe */
(function () {
  'use strict';

  function initCarousel(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hc-dot]'));
    var counter = root.querySelector('[data-hc-counter]');
    var progress = root.querySelector('[data-hc-progress]');
    var prevBtn = root.querySelector('[data-hc-prev]');
    var nextBtn = root.querySelector('[data-hc-next]');
    var total = slides.length;
    if (total <= 1) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var idx = 0;
    var timer = null;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function restartProgress() {
      if (!progress) return;
      progress.classList.remove('is-running');
      // force reflow to restart the animation
      void progress.offsetWidth;
      progress.style.animationDuration = interval + 'ms';
      progress.classList.add('is-running');
    }

    function go(n) {
      idx = (n + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
      restartProgress();
    }

    function next() { go(idx + 1); }
    function prev() { go(idx - 1); }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(next, interval);
      restartProgress();
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hc-dot'), 10)); start(); });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Pause when off-screen for performance
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    go(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-hero-carousel]');
    if (root) initCarousel(root);
  });
})();
